import HCLText from './HCLText';
import HCLTreeMxCellRenderer from '../HCLCellRenderer/HCLTreeMxCellRenderer';
import HCLVertexState from '../HCLCellState/HCLVertexState';

interface NoParamConstructor<T extends HCLText> {
  new (): T;
}

abstract class HCLTextHandler<T extends HCLText> {
  private item: T;

  private readonly Typed: NoParamConstructor<T>;

  private initialized = false;

  protected readonly cellState: HCLVertexState;

  protected abstract shouldTextBeVisible(): boolean;

  constructor(Type: NoParamConstructor<T>, cellState: HCLVertexState) {
    this.cellState = cellState;
    this.Typed = Type;
    this.item = new this.Typed();
  }

  public initText(renderer: HCLTreeMxCellRenderer): void {
    if (!this.initialized) {
      this.item = new this.Typed();
      renderer.initializeLabel(this.cellState, this.item);
      this.initialized = true;
    }
  }

  public updateText(): void {
    if (!this.initialized) {
      return;
    }
    if (this.shouldTextBeVisible()) {
      this.item.update(this.cellState);
    } else {
      this.destroyText();
    }
  }

  destroyText(): void {
    if (!this.initialized) {
      return;
    }
    this.item.destroy();
    this.initialized = false;
  }
}

export default HCLTextHandler;
